export var RequestError;
(function(RequestError) {
    RequestError[RequestError["UserNotFound"] = 0] = "UserNotFound";
    RequestError[RequestError["FriendLimitReached"] = 1] = "FriendLimitReached";
    RequestError[RequestError["GeneralError"] = 2] = "GeneralError";
})(RequestError || (RequestError = {}));
